<template>
  <div class="training">
    <h1 class="page-title">Training</h1>
    <training-form></training-form>
  </div>
</template>

<script>
import trainingForm from "@/components/trainingForm";
import auth from "@/helpers/auth";

export default {
  components: {
    trainingForm
  },

  beforeRouteEnter(to, from, next) {
    if (!auth.signedIn()) return next("/sign-in");
    next();
  }
};
</script>
